import React, { createContext, useState, useContext, ReactNode } from 'react';

interface HighlightedMessageContextProps {
  highlightedMessage: string | null;
  setHighlightedMessage: React.Dispatch<React.SetStateAction<string | null>>;
}

const HighlightedMessageContext = createContext<
  HighlightedMessageContextProps | undefined
>(undefined);

export const HighlightedMessageProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [highlightedMessage, setHighlightedMessage] = useState<string | null>(
    null,
  );

  return (
    <HighlightedMessageContext.Provider
      value={{ highlightedMessage, setHighlightedMessage }}
    >
      {children}
    </HighlightedMessageContext.Provider>
  );
};

export const useHighlightedMessage = (): HighlightedMessageContextProps => {
  const context = useContext(HighlightedMessageContext);
  if (!context) {
    throw new Error(
      'useHighlightedMessage must be used within a HighlightedMessageProvider',
    );
  }
  return context;
};
